import {Injectable} from "@angular/core"
import {TextureTileLoader} from "@cm/three-texture-streaming-browser"

const WORKER_ASSET_PATH = "assets/texture-tile-loader.worker.js"

// Root singleton so the worker, its bitmap cache, and its concurrency budget are shared by every
// consumer that needs tile data - the three.js live-preview atlas streamer
// (ThreeTextureTilesManagerService, component-scoped and possibly instantiated many times per
// session), the interactive Cycles renderer's tile assembly (LocalPreviewRenderingService) and the
// texture editor's page supplier (ImageOpDataObjectPageSupplierPaged) -
// rather than each spinning up its own independent worker. Never explicitly disposed: as a root
// singleton it lives for the app's session.
@Injectable({
    providedIn: "root",
})
export class TextureTileLoaderService extends TextureTileLoader {
    constructor() {
        super(WORKER_ASSET_PATH)
    }
}
